import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    disableLcdSubscriptions,
    disableLcdSubscriptionsProgress,
    stopSubscriptionDisable,
} from 'src/openapi/admin/apis/BulkLcdSubscriptionDisableApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    LCD_SUBSCRIPTION_MODAL_WIDTH,
    LCS_SUBSCRIPTION_TITLES,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
} from '../constants';
import {
    UpdateLcdCreditAnalysisSubscriptionModal,
} from '../update-lcd-credit-analysis-subscription.modal';

import {
    setBackgroundTask,
    setShown,
    setUuid,
    unsubscribeFromLcdCreditAnalysisTaskSelector,
    unsubscribeFromLcdCreditAnalysisUuidSelector,
} from './unsubscribe-from-lcd-credit-analysis.slice';

import type {BulkLcdEnabledRequest} from 'src/openapi/admin/models/BulkLcdEnabledRequest';

type Props = {
    shown: boolean,
    usersIds: number[],
    onDone: () => void,
    onClose: () => void,
};

export const UnsubscribeFromLcdCreditAnalysisTool = ({shown, usersIds, onDone, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<BulkLcdEnabledRequest>
            shown={shown}
            onClose={onClose}
            width={LCD_SUBSCRIPTION_MODAL_WIDTH}

            toolTask={TOOL_TASK}
            toolName={LCS_SUBSCRIPTION_TITLES.UNSUBSCRIBE}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={unsubscribeFromLcdCreditAnalysisTaskSelector}
            uuidSelector={unsubscribeFromLcdCreditAnalysisUuidSelector}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(bulkLcdDisableRequest, options) => (
                apiDispatch(disableLcdSubscriptions({...options, bulkLcdDisableRequest}))
            )}
            getProgress={id => apiDispatch(disableLcdSubscriptionsProgress({id}))}
            stopAction={id => apiDispatch(stopSubscriptionDisable({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) => (
                <UpdateLcdCreditAnalysisSubscriptionModal {...{
                    usersIds,
                    subscribe: false,
                    onCloseModal,
                    processAction}}
                />
            )}
        </BulkActionTool>
    );
};
